import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJGeneratePrivacySettings from '../../../FJImageToImage/FJGeneratePrivacySettings/FJGeneratePrivacySettings.jsx';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor.js';

const FJGeneratePrivacySettingsContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const privacyStatus = useSelector(state => state.aiPhotoEditor.privacyStatus);

    const _onPrivacySettingChange = (value, callback) => {
        dispatch(FJActionAIPhotoEditor.setPrivacySettingAction(value));
        callback(true);
    };
    return (
        <FJGeneratePrivacySettings
            privacyStatus={privacyStatus}
            onPrivacySettingChange={_onPrivacySettingChange}
            placement='topLeft'
        />
    );
};

export default FJGeneratePrivacySettingsContainer;
